import React, { Fragment, forwardRef, useMemo, useState } from 'react';
import TopBarSubMenuItem, { ITopBarSubMenuItem } from './TopBarSubMenuItem';
import {
  Button,
  ButtonThemes,
  ChevronArrowDownIcon,
  DropdownMenu,
} from 'plataforma-fundacao-componentes';
import { clsx } from 'helpers/utils/HTMLUtils';
import styles from './styles.module.scss';

export interface ITopBarMenuItem {
  label: string;
  dataTestId?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  subItems?: ITopBarSubMenuItem[];
  disabled?: boolean;
}

export default function TopBarMenuItem({
  label,
  dataTestId,
  onClick,
  subItems,
  disabled,
}: ITopBarMenuItem) {
  const [dropdownOpened, setDropdownOpened] = useState(false);

  const chevronIcon = useMemo(() => {
    if (subItems && subItems.length) {
      return (
        <div
          className={clsx([
            styles.chevronIcon,
            dropdownOpened ? styles.active : '',
          ])}
        >
          <ChevronArrowDownIcon />
        </div>
      );
    }
    return null;
  }, [subItems, dropdownOpened]);

  return (
    <Fragment>
      <DropdownMenu
        opened={dropdownOpened}
        setOpened={setDropdownOpened}
        className={styles.dropdownMenu}
        closeOnOutClick
        content={subItems?.map((it: ITopBarSubMenuItem, key: number) => {
          const Rend = forwardRef(() => (
            <TopBarSubMenuItem
              {...it}
              click={() => setDropdownOpened(!dropdownOpened)}
            />
          ));
          return <Rend key={key} />;
        })}
      >
        <Button
          rightIcon={chevronIcon}
          theme={ButtonThemes.HeaderSecondary}
          data-testid={dataTestId}
          onClick={(event) => {
            setDropdownOpened(!dropdownOpened);
            if (typeof onClick === 'function') {
              onClick(event);
            }
          }}
          disabled={disabled}
        >
          {label}
        </Button>
      </DropdownMenu>
    </Fragment>
  );
}
